// The intent statement. R-01, R-02, 5.16 — and *Berman v. Freedom Financial
// Network*, 30 F.4th 849 (9th Cir. 2022), which invalidated assent where the
// button "did not indicate to the user what action would constitute assent."
//
// The version is sent to the server and stored in the audit record with the
// signature. Changing this text without changing the version would make every
// past record cite words nobody was shown, so the two move together.
//
// **This wording has not been through legal review.** It matches the example
// R-02 gives and is placeholder-grade; the version string says so, and it is
// deliberately awkward to leave that way.

export const INTENT_STATEMENT_VERSION = 'p0-intent-unversioned';

export const INTENT_STATEMENT =
  'By clicking Sign, I agree that this electronic signature is the legal ' +
  'equivalent of my handwritten signature.';

/**
 * The label on the control that performs the signing.
 *
 * Signing language, never "Continue", "Next" or "Submit" (R-01). A generic
 * label is the specific defect *Berman* turned on.
 */
export const SIGN_BUTTON_LABEL = 'I agree and sign';
